import { render, staticRenderFns } from "./ImoFalForm4Form.vue?vue&type=template&id=7aa89487"
import script from "./ImoFalForm4Form.vue?vue&type=script&lang=js"
export * from "./ImoFalForm4Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports